angular.module('dealerware.web.filters').filter('filterInternationalizationDate', [  '$dealerwareInternationalizationDateFormats',
                                                                                function($dealerwareInternationalizationDateFormats) {
    return function(strDate, defaultLang = null) {
        const datePattern = $dealerwareInternationalizationDateFormats.anyPatternDate;
        const timePattern = $dealerwareInternationalizationDateFormats.anyPatternTime;
        const lang = defaultLang ? defaultLang : $dealerwareInternationalizationDateFormats.language();
        const selectFormat = $dealerwareInternationalizationDateFormats.getFormat(lang);

        const formatDate = function(oldDate) {
            if (Date.parse(oldDate)) {
                const formattedDate = moment(oldDate).format(selectFormat);
                return formattedDate;
            }

            return oldDate;
        }

        const formatTime = function(oldDate) {
            const is24HrsFormat = () => {
                for (langItem in $dealerwareInternationalizationDateFormats.languages24hrs) {
                    if (lang.indexOf($dealerwareInternationalizationDateFormats.languages24hrs[langItem]) !== -1) {
                        return true;
                    }
                }
                return false;
            };

            const timeFormatUS = $dealerwareInternationalizationDateFormats.timeFormats['en-US'];
            const timeFormatCA = $dealerwareInternationalizationDateFormats.getTimeFormat();
            const getSTRTime = oldDate.match(timePattern)[0];
            const CATimeFormat =  is24HrsFormat() ? moment(getSTRTime, timeFormatUS).format(timeFormatCA) : getSTRTime;
            return strDate.replace(getSTRTime, CATimeFormat);
        }

        if (strDate && typeof strDate === 'string') {
            return formatTime(strDate).split(' ').map((dateSection, i) => {
                if (datePattern.test(dateSection)) {
                    return formatDate(new Date(dateSection));
                }
                return dateSection;
            }).join(' ');
        } else if(strDate && Date.parse(strDate)) {   
            return formatDate(strDate);
        }

        return strDate;
    };
}]);